import { SetProfileInfo } from './IdentityActions';
import {
    SetBasicSearchData,
    SetAdvancedSearchData,
    SetNewPage,
    SetBasicSearchDataAndResetDaySpan,
    SetSearchSelectedItem,
    SetBasicSearchDataAndResetAdvancedCriteria
} from './SearchActions';
import { SetVisitInfo } from './VisitActions';
import { SetStatus } from './StatusActions';
import { ISearchData } from '../models/ISearchData';
import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/ActionTypes';
import { SetRegisterData } from './RegisterActions';

export {
    SetProfileInfo,
    SetBasicSearchData,
    SetAdvancedSearchData,
    SetNewPage,
    SetVisitInfo,
    SetStatus,
    SetBasicSearchDataAndResetDaySpan,
    SetFullClientState,
    SetRegisterData,
    SetSearchSelectedItem,
    SetBasicSearchDataAndResetAdvancedCriteria
};

function SetFullClientState(data: ISearchData): AnyAction {
    return {
        type: ActionTypes.SET_FULL_CLIENT_STATE,
        payload: data
    }
}


// WEBPACK FOOTER //
// ./src/actions/ActionsIndex.tsx